import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type {
  CreateBusinessEntity,
  CreateBusinessEntityInput,
  CreateBusinessEntityVariables,
  DeleteBusinessEntity,
  DeleteBusinessEntityVariables,
  UpdateBusinessEntity,
  UpdateBusinessEntityVariables,
} from 'types/graphql';

const CREATE_BUSINESS_ENTITY = gql`
  mutation CreateBusinessEntity($input: CreateBusinessEntityInput!) {
    createBusinessEntity(input: $input) {
      id
      name
    }
  }
`;

const UPDATE_BUSINESS_ENTITY = gql`
  mutation UpdateBusinessEntity($id: Int!, $input: UpdateBusinessEntityInput!) {
    updateBusinessEntity(id: $id, input: $input) {
      id
    }
  }
`;

const DELETE_BUSINESS_ENTITY = gql`
  mutation DeleteBusinessEntity($id: Int!) {
    deleteBusinessEntity(id: $id) {
      id
    }
  }
`;

export function useCreateBusinessEntity() {
  const [mutate, { loading, error }] = useMutation<CreateBusinessEntity, CreateBusinessEntityVariables>(
    CREATE_BUSINESS_ENTITY
  );
  const create = useCallback((input: CreateBusinessEntityInput) => mutate({ variables: { input } }), [mutate]);
  return { create, loading, error };
}

export function useUpdateBusinessEntity() {
  const [mutate, { loading, error }] = useMutation<UpdateBusinessEntity, UpdateBusinessEntityVariables>(
    UPDATE_BUSINESS_ENTITY
  );
  const update = useCallback(
    ({ id, input }: UpdateBusinessEntityVariables) => mutate({ variables: { id, input } }),
    [mutate]
  );
  return { update, loading, error };
}

export function useDeleteBusinessEntity() {
  const [mutate, { loading, error }] = useMutation<DeleteBusinessEntity, DeleteBusinessEntityVariables>(
    DELETE_BUSINESS_ENTITY
  );
  const remove = useCallback((id: number) => mutate({ variables: { id } }), [mutate]);
  return { remove, loading, error };
}
